package one.healthium.profile.ui.update_name

internal sealed interface UpdateNameEvent {
    data object OnNameUpdated : UpdateNameEvent
}
